import { Navigate, useLocation } from 'react-router';
import { useAuth } from './AuthContext';
import { AUTH_PATHS } from '@/feature/authentication/constants';
import { useMfa } from '@/feature/authentication/MfaContext';
import { useMfaSetupGuard } from '@/feature/authentication/hooks/useMfaSetupGuard';
import { readPostLoginRedirect } from '@/feature/authentication/utils/postLoginRedirect';

interface PublicRouteProps {
  children: React.ReactNode;
}

export const PublicRoute = ({ children }: PublicRouteProps) => {
  const { isAuthenticated, isLoading: authLoading, user } = useAuth();
  const location = useLocation();
  const { mfaVerificationMode } = useMfa();
  const { data: mfaGuard } = useMfaSetupGuard(user?.email);

  const needsMfaSetup = mfaGuard?.setupRequired === true;
  const isPhoneSetupRoute =
    location.pathname === AUTH_PATHS.MFA_SETUP_PHONE ||
    (location.pathname === AUTH_PATHS.MFA_VERIFICATION &&
      mfaVerificationMode === 'phone-setup');

  if (
    isAuthenticated &&
    !authLoading &&
    !(needsMfaSetup && isPhoneSetupRoute)
  ) {
    // Peek only — clearing during render is unsafe under Strict Mode.
    // Storage is cleared in ProtectedRoute once the user reaches an app route.
    return (
      <Navigate
        to={readPostLoginRedirect()}
        state={{ from: location }}
        replace
      />
    );
  }

  return <>{children}</>;
};
